import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LinkCardUnlock.css';

export function isEarlyReleaseUser(user) {
  return user?.active_school?.early_release === true;
}

export function cardLinkStatus(user, cardsResponse) {
  if (isEarlyReleaseUser(user)) return 'linked';
  if (!cardsResponse) return 'unknown';
  const raw = cardsResponse?.results || cardsResponse?.data || cardsResponse;
  if (!Array.isArray(raw)) return 'unknown';
  return raw.some((card) => (card?.status || 'active') === 'active') ? 'linked' : 'unlinked';
}

export function linkCardPoints(data) {
  const value = Number(data?.link_card ?? data?.linkCard);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function linkCardLabel(points) {
  const pts = Number(points) || 0;
  if (pts <= 0) return 'Link my card';
  return `Link my card +${pts.toLocaleString('en-US')} pts`;
}

export function LinkCardUnlockBar({ points, dock }) {
  return (
    <div className={`link-card-bar${dock ? ' is-dock' : ''}`}>
      <p>Link your card to unlock rewards</p>
      <Link to="/settings?tab=cards">{linkCardLabel(points)}</Link>
    </div>
  );
}

export function LinkCardPrompt({ points, onClose }) {
  return (
    <div className="link-card-modal" role="presentation" onClick={onClose}>
      <div
        className="link-card-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="link-card-title"
        onClick={(event) => event.stopPropagation()}
      >
        <span className="link-card-lock" aria-hidden="true">
          <svg viewBox="0 0 16 20">
            <rect x="1" y="8" width="14" height="11" rx="2" />
            <path d="M4 8V5.5a4 4 0 0 1 8 0V8" />
          </svg>
        </span>
        <h2 id="link-card-title">Almost there</h2>
        <p>Link your card to start earning points toward rewards.</p>
        <Link className="link-card-primary" to="/settings?tab=cards">
          {linkCardLabel(points)}
        </Link>
        <button type="button" className="link-card-secondary" onClick={onClose}>
          Keep exploring rewards
        </button>
      </div>
    </div>
  );
}
